import React from 'react';

export const DrawerFooter = ({ children }: { children: React.ReactNode }) => (
  <>
    <div className="drawer-footer">{children}</div>
    <style jsx>
      {`
        .drawer-footer {
          padding: 10px;
          border-top: solid 1px #f0f0f0;
        }
      `}
    </style>
  </>
);
